import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  boxfilters: {
    width: '100%',
    paddingBottom: '5px',
    display: 'flex',
    alignItems: 'center'
  },
  typography: {
    fontWeight: 'bold',
    fontSize: '0.9em',
    letterSpacing: '0.03em',
    color: '#606060',
    '@media all and (max-width: 1250px)': {
      fontSize: '0.8em'
    }
  },
  typographyFilters: {
    marginLeft: '1em',
    fontWeight: 'bold',
    fontSize: '0.9em',
    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer'
    },
    '@media all and (max-width: 1250px)': {
      fontSize: '0.8em'
    },
    color: '#00A88F'
  },
  typographyFilterSelected: {
    marginLeft: '1em',
    fontWeight: 'bold',
    fontSize: '0.9em',
    color: '#606060',
    '@media all and (max-width: 1250px)': {
      fontSize: '0.8em'
    }
  },
  buttonResetFilter: {
    marginLeft: '0.5em',
    height: '18px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#f2f2f2',

    border: '1px solid #028B7E',
    borderRadius: '23px',
    '&:hover': {
      backgroundColor: '#fff'
    }
  },
  closeIconButtonResetRoute: {
    height: '13px',
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #028B7E',
    borderRadius: '23px',
    '&:hover': {
      backgroundColor: '#fff'
    }
  },
  typographyButton: {
    paddingLeft: 5,
    fontFamily: 'Raleway',
    fontSize: '0.8em',
    letterSpacing: '0.05em',
    color: '#028B7E'
  },
  closeIconButtonReset: {
    fontSize: '1em',
    paddingLeft: 5,
    color: '#028B7E',
    cursor: 'pointer'
  }
}))

export default useStyles
